<fuse-progress-bar></fuse-progress-bar>
<ng-container *ngIf="fuseConfig.layout.style === 'vertical-layout'">
  <vertical-layout></vertical-layout>
</ng-container>
